// extracted by mini-css-extract-plugin
module.exports = {"day":"day-34ho_ day-1Symv","dayOfWeekName":"dayOfWeekName-2R3M0","dayOfWeekName_withPrices":"dayOfWeekName_withPrices-34Aw-","week":"week-3vEer"};